/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */


//count number of properties of an object, use as 'var len = Object.size(obj)'
Object.size = function( obj ) {
	var size = 0;
	for( var key in obj ) {
		if( obj.hasOwnProperty(key) ) size ++;
	}
	return size;
};


export function arr_inArray( elem, arr, i ) {
	return arr==null ? -1 : arr.indexOf(elem,i);
}


export function str_trim( s ) {
	return s==null ? '' : (s+'').trim();
}

export function replaceTextAt( text, index, replacement ) {
	return text.substring(0,index) + replacement + text.substring(index+replacement.length);
}


/**
 * Replaces text for all elements in the given array.
 * @param {Array} elems
 * @param {String} text
 */
export function replaceText( elems, text ) {
	for( var i=elems.length; i--; ) elems[i].textContent = text;
}


export function mj_return_false() {
	return false;
}

export function escapeRegExp( str ) {
	return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}



var htmlspecialcharsRegEx = /\r|&|<|>|"|\n/g;

export function htmlspecialchars( str, quotes, no_auto_br ) {
	if( typeof str === 'undefined' || str===null ) return '';
	return str.toString().replace(htmlspecialcharsRegEx,function(c) {
		if( c=='\r' ) return '';
		else if( c=='&' ) return '&amp;';
		else if( c=='<' ) return '&lt;';
		else if( c=='>' ) return '&gt;';
		else if( c=='"' ) return quotes ? '&quot;' : '"';
		else if( c=='\n' ) return no_auto_br ? '\n' : '<br />\n';
		return c;
	});
}


export function htmlspecialchars_decode( string, quoteStyle ) {
	var optTemp = 0;
	var i = 0;
	var noquotes = false;
	if( typeof quoteStyle === 'undefined') quoteStyle = 2;
	string = string.toString()
		.replace(/&lt;/g,'<')
		.replace(/&gt;/g,'>');
	var OPTS = {
		'ENT_NOQUOTES': 0,
		'ENT_HTML_QUOTE_SINGLE': 1,
		'ENT_HTML_QUOTE_DOUBLE': 2,
		'ENT_COMPAT': 2,
		'ENT_QUOTES': 3,
		'ENT_IGNORE': 4,
	};
	if( quoteStyle===0 ) noquotes = true;
	if( typeof quoteStyle !== 'number' ) {
		quoteStyle = [...quoteStyle];
		for( i=0; i<quoteStyle.length; i++ ) {
			if( OPTS[quoteStyle[i]]===0 ) noquotes = true;
			else if( OPTS[quoteStyle[i]] ) optTemp = optTemp | OPTS[quoteStyle[i]];
		}
		quoteStyle = optTemp;
	}
	if( quoteStyle & OPTS.ENT_HTML_QUOTE_SINGLE ) string = string.replace(/&#0*39;/g,"'");
	if( !noquotes ) string = string.replace(/&quot;/g,'"');
	// Put this in last place to avoid escape being double-decoded
	string = string.replace(/&amp;/g,'&');
	return string;
}




/*eslint no-inner-declarations: "off" */

export let elementHasClassName, elementHasOneOfClassNames, addClass, removeClass, removeMultipleClasses0, toggleMultipleClasses0;


if( 'classList' in Element.prototype ) {

	/**
	 * DOM-only replacement for jquery .hasClass()
	 *
	 * @param Element elem
	 * @param String className
	 * @return boolean
	 */
	elementHasClassName = function( elem, className ) {
		return elem.classList.contains(className);
	};

	/**
	 * return whether element has one of the classNames provided
	 *
	 * @param Element elem
	 * @param Array classNames
	 * @return boolean
	 */
	elementHasOneOfClassNames = function( elem, classNames ) {
		const l = classNames.length;
		for( let i=0; i<l; ++i ) {
			if( elem.classList.contains(classNames[i]) ) {
				return true;
			}
		}
		return false;
	};

	/**
	 * DOM-only replacement for jquery .addClass()
	 *
	 * @param Element elem
	 * @param String className  unlike in jquery, this may contain a single className only!
	 */
	addClass = function( elem, className ) {
		elem.classList.add(className);
	};

	/**
	 * DOM-only replacement for jquery .removeClass()
	 *
	 * @param Element elem
	 * @param String className  unlike in jquery, this may contain a single className only!
	 */
	removeClass = function( elem, className ) {
		elem.classList.remove(className);
	};


	removeMultipleClasses0 = function( elem, classNames ) {
		const l = classNames.length;
		for( let i=0; i<l; ++i ) {
			let cn;
			if( elem.classList.contains((cn=classNames[i])) ) {
				elem.classList.remove(cn);
			}
		}
	};

	toggleMultipleClasses0 = function( elem, cn_map ) {
		for( const cn in cn_map ) {
			if( cn_map.hasOwnProperty(cn) ) {
				const cn_tog = cn_map[cn];
				if( cn_tog && !elem.classList.contains(cn) ) {
					elem.classList.add(cn);
				} else if( !cn_tog && elem.classList.contains(cn) ) {
					elem.classList.remove(cn);
				}
			}
		}
	};

} else {

	/**
	 * DOM-only replacement for jquery .hasClass()
	 *
	 * @param Element elem
	 * @param String className
	 * @return boolean
	 */
	elementHasClassName = function( elem, className ) {
		return (' '+elem.className+' ').replace(/[\n\t]/g,' ').indexOf(' '+className+' ') !== -1;
	};

	/**
	 * return whether element has one of the classNames provided
	 *
	 * @param Element elem
	 * @param Array classNames
	 * @return boolean
	 */
	elementHasOneOfClassNames = function( elem, classNames ) {
		var tmp = (' '+elem.className+' ').replace(/[\n\t]/g,' ');
		const l = classNames.length;
		for( let i=0; i<l; ++i ) {
			if( tmp.indexOf(' '+classNames[i]+' ') !== -1 ) {
				return true;
			}
		}
		return false;
	};

	/**
	 * DOM-only replacement for jquery .addClass()
	 * - requires IE8+
	 *
	 * @param Element elem
	 * @param String className  unlike in jquery, this may contain a single className only!
	 */
	addClass = function( elem, className ) {
		elem.className += ' ' + className;
	};

	/**
	 * DOM-only replacement for jquery .removeClass()
	 * - requires IE8+
	 *
	 * @param Element elem
	 * @param String className  unlike in jquery, this may contain a single className only!
	 */
	removeClass = function( elem, className ) {
		elem.className = elem.className.replace(new RegExp('(^|\\b)'+className.split(' ').join('|')+'(\\b|$)', 'gi'),' ');
	};

	removeMultipleClasses0 = function( elem, classNames ) {
		let altered = false;
		let elemClassName = elem.className;
		const l = classNames.length;
		for( let i=0; i<l; ++i ) {
			const cn = classNames[i];
			if( (' '+elemClassName+' ').replace(/[\n\t]/g,' ').indexOf(' '+cn+' ') !== -1 ) {
				elemClassName = elemClassName.replace(new RegExp('(^|\\b)'+cn.split(' ').join('|')+'(\\b|$)','gi'),' ');
				altered = true;
			}
		}
		if( altered ) {
			elem.className = elemClassName;
		}
	};

	toggleMultipleClasses0 = function( elem, cn_map ) {
		let cn_tog, contains;
		let altered = false;
		let elemClassName = elem.className;
		for( const cn in cn_map ) {
			if( cn_map.hasOwnProperty(cn) ) {
				cn_tog = cn_map[cn];
				contains = (' '+elemClassName+' ').replace(/[\n\t]/g,' ').indexOf(' '+cn+' ') !== -1;
				if( cn_tog && !contains ) {
					elemClassName += ' '+cn;
					altered = true;
				} else if( !cn_tog && contains ) {
					elemClassName = elemClassName.replace(new RegExp('(^|\\b)'+cn.split(' ').join('|')+'(\\b|$)','gi'),' ');
					altered = true;
				}
			}
		}
		if( altered ) {
			elem.className = elemClassName;
		}
	};

}

export function toggleClass( elem, className, toggle ) {
	if( toggle ) addClass(elem,className);
	else removeClass(elem,className);
}

export function toggleMultipleClasses( $node, cn_map ) {
	if( $node.length ) toggleMultipleClasses0($node[0],cn_map);
}

export function removeMultipleClasses( $node, classNames ) {
	if( $node.length ) removeMultipleClasses0($node[0],classNames);
}



export function mj_make_filename( s ) {
	var r='', c, l=s.length, rc='/\\:<>|\n\r';
	for( var i=0; i<l; ++i ) {
		c = s.charAt(i);
		r += rc.indexOf(c)===-1 ? c : '_';
	}
	return r;
}

export function array_unique( arr ) {
	return arr.filter( function( v, i ) {
		return arr.indexOf(v)==i;
	} );
}

export function array_merge_unique( ...arrays ) {
	let res = [];
	arrays.forEach( (arr) => {
		res = [...res,...arr];
	} );
	return res.filter( (item,index) => res.indexOf(item)===index );
}

export function arrays_equal( a, b ) {
	var i, l=a.length;
	if( l!==b.length ) return false;
	for( i=0; i<l; ++i ) {
		if( a[i]!==b[i] ) return false;
	}
	return true;
}

export function array_remove( arr, value ) {
	return arr.filter( function(e) {
		return e != value;
	});
}

export function get_array_of_strings_from_ml_text( str ) {
	var lines_arr = Array.isArray(str) ? str : str.split('\n');
	for( var i=0; i<lines_arr.length; ++i ) lines_arr[i] = str_trim(lines_arr[i]);
	return array_unique( lines_arr.filter( function(e) {
		return e!='';
	} ) );
}

export function build_localed_string_object( str, locales ) {
	let obj = {};
	for( var i=0; i<locales.length; ++i ) obj[locales[i]] = str;
	return obj;
}

export function parse_localized_string( val ) {
	if( typeof val !== 'object' ) {
		val = val.toString();
		if( val.length>0 && val[0]==='{' ) {
			// eslint-disable-next-line no-useless-catch
			try {
				const obj = JSON.parse(val);
				return obj;
			} catch( err ) {
				// rethrow
				throw err;
			}
		}
	}
	return val;
}

export function is_localized_string_empty( val ) {
	let obj = parse_localized_string(val);
	if( typeof obj === 'string' ) {
		if( obj==='' ) {
			return true;
		}
	}
	// texts in all locales empty?
	for( const v of Object.values(obj) ) {
		if( v!=='' && v!==null ) {
			return false;
		}
	}
	return true;
}

export function get_localized_string2( val, locale, default_locale ) {
	let obj = parse_localized_string(val);
	if( typeof obj === 'string' ) {
		// plain, non-localized string ..
		return obj.trim();
	}
	if( typeof obj === 'object' ) {
		if( obj.hasOwnProperty(locale) ) return obj[locale].trim();
		if( typeof default_locale !== 'undefined' && obj.hasOwnProperty(default_locale) ) return obj[default_locale].trim();
	}
	return obj;
}


export function get_values_from_array_of_objects( arr, key ) {
	var r=[], l=arr.length, i;
	for( i=0; i<l; ++i ) r.push(arr[i][key]);
	return r;
}

var addslashesRegEx1 = /[\\"']/g;
// eslint-disable-next-line no-control-regex
var addslashesRegEx2 = /\u0000/g;
export function addslashes(str) {
	if( typeof str === 'undefined' || str===null ) return '';
	return str.toString().replace(addslashesRegEx1,'\\$&').replace(addslashesRegEx2,'\\0');
}

export function str_repeat(str,cnt) {
	return new Array(cnt+1).join(str);
}

export function x_split( str, sep ) {
	return str==='' ? [] : str.split(sep);
}

export function split_once( str, sep ) {
	var fs = str.split(sep);
	return fs.length===2 ? fs : [fs.shift(),fs.join(sep)];
}

export function is_valid_email( str ) {
	// TODO: add support for addresses like "displayname <address>"
	str = str_trim(str);
	if( str.length===0 ) return false;
	if( str.indexOf(',')!==-1 || str.indexOf(';')!==-1 ) return false;
	var p = str.lastIndexOf('@');
	if( p<=0 || str.length-p<=3 || str.lastIndexOf('.')<=p+1 ) return false;
	// return p>0 && str.length-p>3 && str.lastIndexOf('.')>p+1;
	var emailRegEx1 = /^[a-z0-9][a-z0-9_.+-]*@[a-z0-9.-]+$/ig;
	return !!str.match(emailRegEx1);
}

export function is_valid_email_list( str ) {
	// TODO: add support for addresses like "displayname <address>"
	str = str_trim(str);
	if( str.length===0 ) return false;
	var emails = str.split(/[,;\s]+/),
		len = emails.length,
		cnt = 0,
		p, i, email;
	for( i=0; i<len; ++i ) {
		email = str_trim(emails[i]);
		if( email==='' ) continue;
		p = email.lastIndexOf('@');
		if( p<=0 || email.length-p<=3 || email.lastIndexOf('.')<=p+1 ) return false;
		cnt ++;
	}
	return cnt > 0;
}

export function clip( n, lower, upper ) {
	return Math.max(lower,Math.min(n,upper));
}


export function split_text_on_separators( raw_value, list_sep, xtr_val_fun ) {
	if( typeof raw_value === 'undefined' ) return [];
	var dtmp = [ raw_value ];
	for( var i=0; i<list_sep.length; i++ ) {
		var s = list_sep.charAt(i);
		var dtmp2 = dtmp;
		var dtmp2_len = dtmp2.length;
		dtmp = [];
		for( var d2=0; d2<dtmp2_len; ++d2 ) {
			var dtmp3 = dtmp2[d2].split(s);
			var dtmp3_len = dtmp3.length;
			for( var d3=0; d3<dtmp3_len; ++d3 ) {
				var v = xtr_val_fun( str_trim(dtmp3[d3]) ).toString();
				if( v.length ) dtmp.push(v);
			}
		}
	}
	return dtmp;
}


// export function mj_wrap( v, len ) {
// 	while( v<0 ) v += len;
// 	return v%len;
// }

// export function mj_wrap2range( v, lo, hi ) {
// 	var len = hi-lo+1;
// 	while( v<lo ) v += len;
// 	return lo+((v-lo)%len);
// }

// export function mj_wrap_ui_logic( v, d, l ) {
// 	if( d===0 ) return v;						// no delta = no change
// 	else if( v===0 && d<0 ) 	return l-1;		// go to last pos
// 	else if( v===l-1 && d>0 )	return 0;		// to first pos
// 	return clip(v+d,0,l-1);				// keep clipped in range
// }


export function mj_find_object_array_entry_by_key( arr, key, val ) {
	var l=arr.length, i, o;
	for( i=0; i<l; ++i ) {
		o = arr[i];
		if( o.hasOwnProperty(key) && o[key]==val ) return o;
	}
	return null;
}

export function mj_find_array_array_entry_by_idx( arr, idx, val ) {
	var l=arr.length, i, o;
	for( i=0; i<l; ++i ) {
		o = arr[i];
		if( o[idx]==val ) return o;
	}
	return null;
}


export function mj_create_unique_id( pfx ) {
	return pfx + (++mj_create_unique_id._mj_unq_id_counter);
}
mj_create_unique_id._mj_unq_id_counter = 0;


export function mj_shorten_text( text, maxlines, maxchars, append_str ) {
	var shortened = false;
	if( maxchars && text.length>maxchars ) {
		text = text.slice(0,maxchars);
		shortened = true;
	}
	if( maxlines ) {
		var lines = text.split('\n');
		if( lines.length > maxlines ) {
			text = lines.slice(0,maxlines).join('\n');
			shortened = true;
		}
	}
	if( shortened && append_str ) {
		text += append_str;
	}
	return text;
}

export function mj_extract_location_hash( h ) {
	if( h && h.length>2 && h.indexOf('=')!==-1 ) {
		var p = split_once(h,'='),
			k = p[0].substr(1),
			v = decodeURIComponent(p[1]),
			c,
			e;
		if( (e=k.indexOf('&'))!==-1 ) {
			// remove initial timestamp from request (e.g. "#1234&key=value")
			c = k.substr(0,e);
			k = k.substr(e+1);
		}
		return [k,v,c];
	}
	return [null,null,null];
}


/**
 * Create new object from attributes of parent merged with attributes of child.
 *
 * - same as $.extend({},parent,child)
 * - same as Object.assign({},parent,child)
 *
 * @param object parent
 * @param object child
 * @returns object  new object with attributes of parent and child merged
//  */
// export function mj_extended_object( parent, child ) {
// 	return Object.assign({},parent,child);
// }




/**
 * Create a shallow copy of object.
 *
 * - same as $.extend({},obj)
 * - same as Object.assign({},obj)
 *
 * @param object obj
 * @returns object new object
 */
export function mj_cloned_object( obj ) {
	return Object.assign({},obj);
}


/**
 * Merge the contents of objects together, deep copy contained objects.
 *
 * - same as $.extend(true,out,objA,objB,...)
 */
export function mj_deep_extend( out, ...arguments_ ) {
	if( !out ) {
		return {};
	}
	for( const obj of arguments_ ) {
		if( !obj ) {
			continue;
		}
		for( const [key,value] of Object.entries(obj) ) {
			switch( Object.prototype.toString.call(value) ) {
			case '[object Object]':
				out[key] = out[key] || {};
				out[key] = mj_deep_extend(out[key],value);
				break;
			case '[object Array]':
				out[key] = mj_deep_extend(new Array(value.length),value);
				break;
			default:
				out[key] = value;
			}
		}
	}
	return out;
}


export function fix_url_search( search ) {
	if( search==='' ) return search;
	var fc = search.charAt(0);
	if( fc==='&' ) return '?'+search.substr(1);
	else if( fc==='?' ) return search;
	return '?'+search;
}
// search is e.g. document.location.search (is empty string, or starts with '?')
export function set_parameter_on_url_search( search, key, val ) {
	val = encodeURIComponent(val);
	if( search==='' ) return '?'+key+'='+val;
	var regex = new RegExp('([?|&]'+key+'=)[^&]*','g');
	if( search.match(regex) ) search = search.replace(regex,'$1'+val);
	else search = search+'&'+key+'='+val;
	return fix_url_search(search);
}
export function del_parameter_in_url_search( search, key ) {
	if( search==='' ) return '';
	var regex = new RegExp('([?|&]'+key+'=)[^&]*','g');
	if( search.match(regex) ) search = search.replace(regex,'');
	return fix_url_search(search);
}

//hash is e.g. document.location.hash (is empty string, or starts with '#')
export function set_parameter_on_url_hash( hash, key, val ) {
	val = encodeURIComponent(val);
	if( hash==='' ) return '#'+key+'='+val;
	var regex = new RegExp('([#|&]'+key+'=)[^&]*','g');
	if( hash.match(regex) ) return hash.replace(regex,'$1'+val);
	return hash+'&'+key+'='+val;
}

export function del_parameter_in_url_hash( hash, key ) {
	if( hash==='' ) return hash;
	var regex = new RegExp('([#|&]'+key+'=)[^&]*','g');
	if( hash.match(regex) ) return hash.replace(regex,'');
	return hash;
}


// export function mj_walk_tree( obj, cb ) {
// 	for( var i in obj ) {
// 		if( !obj.hasOwnProperty(i) ) continue;
// 		cb.apply(this,[i,obj[i]]);
// 		if( obj[i]!==null && typeof(obj[i])==='object' ) {
// 			mj_walk_tree(obj[i],cb);
// 		}
// 	}
// }





export function mjRegisterSimpleJQueryPlugin( $, plugin_name, methods ) {
	$.fn[plugin_name] = function( arg ) {
		// -> "this" is a jQuery object
		var args=arguments, rv;
		var erv = this.each( function() {
			// -> "this" is a DOMElement
			if( methods[arg] ) rv = methods[arg].apply(this,Array.prototype.slice.call(args,1));
			else if( typeof arg === 'object' || !arg ) rv = methods.init.apply(this,args);
			else throw new Error('Method '+arg+' does not exist on jQuery.'+plugin_name);
		} );
		return rv===undefined ? erv : rv;
	};
}


export function mjGetMSIEVersion() {
	if( navigator.appName==='Microsoft Internet Explorer' || navigator.appName==='Netscape' ) {
		if( (new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})')).exec(navigator.userAgent)!=null ) return parseFloat(RegExp.$1);
		if( navigator.userAgent.match(/Trident.*rv:11\./) ) return 11;
	}
	return -1;
}


export function mapToObj( map ) {
	const obj = {};
	for( let [k,v] of map ) obj[k] = v;
	return obj;
}


export function DOMElementsStringifyReplacer( name, value ) {
	// console.log('DOMElementsStringifyReplacer name=%o, value=%o',name,value);

	const whitelist = ['id','tagName','className'];//,'outerHTML'];//, 'childNodes'];

	function domToObj( domEl ) {
		let obj = {};
		for( let wlItem of whitelist ) {
			if( domEl[wlItem] instanceof NodeList ) obj[wlItem] = Array.from(domEl[wlItem]);
			else obj[wlItem] = domEl[wlItem];
		}
		// console.log('domToObj domEl=%O, obj=%o',domEl,obj);
		return obj;
	}

	if( name==='' ) return value;
	// if( name==='' ) return domToObj(value);
	// if( Array.isArray(this) ) {
	// 	if( typeof value === 'object' && value instanceof Node ) return domToObj(value);
	// 	return value;
	// }
	// if( whitelist.find( x => ( x === name ) ) ) return value;
	if( typeof value === 'object' && value instanceof Node ) return domToObj(value);
	return value;
}


export const getCircularStringifyReplacer = () => {
	const seen = new WeakSet();
	return (key, value) => {
		if(typeof value === "object" && value !== null) {
			if( seen.has(value)) {
				return;
			}
			seen.add(value);
		}
		return value;
	};
};


/**
 * Returns whether an object is `Promise`-like (i.e. has a `then` method).
 *
 * @param  {Object}  value
 *         An object that may or may not be `Promise`-like.
 *
 * @return {boolean}
 *         Whether or not the object is `Promise`-like.
 */
function isPromise(value) {
	return value !== undefined && value !== null && typeof value.then === 'function';
}

export function copyToClipboard( linkOrPromise ) {
	if(typeof ClipboardItem && navigator.clipboard.write) {
		// NOTE: Safari locks down the clipboard API to only work when triggered
		//   by a direct user interaction. You can't use it async in a promise.
		//   But! You can wrap the promise in a ClipboardItem, and give that to
		//   the clipboard API.
		//   Found this on https://developer.apple.com/forums/thread/691873

		if( isPromise(linkOrPromise) ) {
			const text = new ClipboardItem({
				"text/plain": linkOrPromise.then( link => new Blob([link], { type: "text/plain" }) )
			});
			navigator.clipboard.write([text]);
		} else {
			const text = new ClipboardItem({
				"text/plain": new Blob([linkOrPromise], { type: "text/plain" })
			});
			navigator.clipboard.write([text]);
		}

	} else {
		// NOTE: Firefox has support for ClipboardItem and navigator.clipboard.write,
		//   but those are behind `dom.events.asyncClipboard.clipboardItem` preference.
		//   Good news is that other than Safari, Firefox does not care about
		//   Clipboard API being used async in a Promise.

		if( isPromise(linkOrPromise) ) {
			linkOrPromise.then( link => navigator.clipboard.writeText(link) );
		} else {
			navigator.clipboard.writeText(linkOrPromise);
		}
	}
}

